<div class="passcode" [ngClass]="getSizeClass()">
  <ng-container *ngIf="passcode">
    <div class="shape" [ngClass]="getPasscodeColorClass(obj)" [inlineSVG]="getPasscodeShapeUrl(obj)"></div>
    <img class="picture" [src]="getPasscodePictureUrl(obj)">
  </ng-container>
  <div *ngIf="!passcode" class="not-set-text p-2">
    Not<br>Set
  </div>
</div>
